export default [
  {
    path: 'notifications',
    children: [
      {
        name: 'notifications',
        path: '',
        component: () => import('./NotificationsList.vue'),
        meta: { title: 'Notifications', guard: false }
      },
      {
        name: 'create-notification',
        path: 'create',
        component: () => import('./NotificationForm.vue'),
        meta: { title: 'New Notification' },
        props: {
          type: 'New'
        }
      },
      {
        name: 'edit-notification',
        path: ':id/edit',
        component: () => import('./NotificationForm.vue'),
        meta: { title: 'Edit Notification' },
        props: (route) => ({
          type: 'Edit',
          id: route.params.id
        })
      },
      {
        name: 'view-notification',
        path: ':id/view',
        component: () => import('./NotificationView.vue'),
        meta: {
          title: 'View Notification'
        },
        props: (route) => ({
          id: route.params.id
        })
      }
    ]
  },
]
